import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function PersonalProveedores() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [client, setClient] = useState([]);

    const [tienePermisoGeneral, setTienePermisoGeneral] = useState(false);
    const [tienePermisoPersonal, setTienePermisoPersonal] = useState(false);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map(p => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }

        const tienePermisoGeneralModulo = permisosList.includes('administrarPersonalProveedores');
        const tienePermisoGestionPersonal = permisosList.includes('gestionPersonal');

        if (!tienePermisoGeneralModulo && !tienePermisoGestionPersonal) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);
        setTienePermisoGeneral(tienePermisoGeneralModulo);
        setTienePermisoPersonal(tienePermisoGestionPersonal);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission !== true || !loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item active">Personal y proveedores</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Personal y proveedores</h1>
                                    <p className="dash-subtitle mb-0">Colaboradores, proveedores externos y SISPRO</p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/settings" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver a configuración
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="dash-card mb-4">
                            <div className="dash-card-header">
                                <h2 className="dash-card-title">
                                    <span className="title-icon" aria-hidden="true"><i className="fas fa-users"></i></span>
                                    Opciones
                                </h2>
                            </div>
                            <div className="dash-card-body">
                                <div className="quick-grid">
                                    {tienePermisoPersonal && (
                                        <Link to="/personal" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-md"></i></div>
                                            <p className="quick-title">Personal y profesionales</p>
                                            <p className="quick-sub">Usuarios del consultorio</p>
                                        </Link>
                                    )}

                                    {tienePermisoGeneral && (
                                        <Link to="/proveedores" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-truck"></i></div>
                                            <p className="quick-title">Proveedores</p>
                                            <p className="quick-sub">Terceros y suministros</p>
                                        </Link>
                                    )}

                                    {tienePermisoGeneral && (
                                        <Link to="/usuarios-sispro" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-shield"></i></div>
                                            <p className="quick-title">Usuarios SISPRO</p>
                                            <p className="quick-sub">Integración y perfiles</p>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}
export default PersonalProveedores;
